<!-- 搜索栏 -->
<template>
    <el-pagination
        class="mt_20 mb_100"
        background
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total">
    </el-pagination>
</template>

<script>
    export default {
        data() {
            return {
                currentPage:1//当前页
            }
        },
        props:{
            total:Number,
            pageSize:{
                type:Number,
                default(){
                    return 20;
                }
            },
            current:{
                type:Number,
                default(){
                    return 1;
                }
            }
        },
        watch:{
            current(){
                this.currentPage = this.current ;
            }
        },
        methods: {
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.$emit('pageChange',val);
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>
